function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, "#help_svg__st2{fill:#fd55d8}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M50.4 40.4c-6.2 9.1-18.1 11.8-28.5 11.4C10.1 51.5 3.9 39.6 3 29c-.7-9.8 3.9-17.9 12.4-22.5S31.7 1.9 41 4.1h.2c13.4 5.2 16.6 25.4 9.2 36.3z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M52.4 29c-.2 4.1-.4 8.6-1.9 12.4-1.2 2.8-3 5.4-5.4 7.4-2 .9-4 1.8-5.9 2.6-1.8.7-3.6 1.3-5.5 1.8-2.5.6-5.1.8-7.7.6-3.7-.4-7.2-1.5-10.4-3.4-1.8-.9-3.4-1.9-4.9-3.2-1.7-1.8-2.7-4-4.5-5.6-.4-.4-1.1-.4-1.5 0-.2.2-.3.4-.3.7-.6 4.4 2.5 10.6 5.2 14 3.5 4.2 8.6 6.8 13.8 7.9 10.3 2.3 24.9 0 31.8-8.8 1-1.2 1.5-2.7 1.3-4.2 3.8-7.3 3.6-16.4-2.4-22.9-.4-.4-1.1-.4-1.5 0 0 .2-.1.4-.2.7z",
  fill: "#e0dfe6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "help_svg__st2",
  d: "M55.4 22.2c-1.2-8.4-6-17.9-14.7-20.2-.1-.1-.3-.2-.5-.2-7.9-2.1-15.4-2.8-23 .5-7.1 3.1-13 7.6-15.7 15C-2.3 27.9 1.2 43 10.4 50c9.5 7.2 26.9 3.7 35.8-3.4 7.4-5.8 10.4-15.2 9.2-24.4zm-7.5 16.7c-5.7 8.4-16.8 10.9-26.4 10.6C10.6 49.2 4.8 38.2 4 28.4c-.7-9.1 3.6-16.6 11.5-20.9s15.1-4.3 23.7-2.2h.2c12.4 4.8 15.4 23.5 8.5 33.6z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "help_svg__st2",
  d: "M33.3 27.7l-2.7 1.9c-.9.6-1.8 1.3-2.5 2.1-.4.5-1.1.9-1.8.9-.6 0-1.2-.2-1.7-.7-.5-.4-.7-1-.7-1.6 0-.9.7-1.9 2.1-3l3.9-2.8c1.4-1 2.1-2 2.1-2.8-.1-1.1-.6-2.2-1.6-2.9-.9-.8-2-1.3-3.2-1.3-.9.1-1.7.5-2.4 1-.6.5-1.4.8-2.2 1-.6 0-1.2-.3-1.6-.7-.4-.4-.7-1-.7-1.6 0-1.1 1-2.1 2.9-3 1.3-.7 2.6-1.1 4.1-1.2 2.4 0 4.7 1 6.5 2.6 1.8 1.5 2.9 3.7 2.9 6s-1.1 4.3-3.4 6.1zm-7.9 11.9c-.6 0-1.2-.2-1.7-.6-.5-.4-.8-1-.8-1.7s.2-1.5.7-2.1c.5-.7 1.3-1.2 2.1-1.2.7 0 1.3.3 1.8.8.3.5.5 1 .5 1.6 0 .7-.2 1.3-.5 1.9-.5.8-1.3 1.3-2.1 1.3z"
});

var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "help_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 59.1 65",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default SvgHelp;